import React from 'react';
import PropTypes from 'prop-types';
import { View, Modal as NativeModal } from 'react-native';
import { Device } from 'DeviceUtils';

export const MODAL_THEME_TYPE = {
    DARK: 'dark',
    LIGHT: 'light'
};

const Modal = ({ animationType, transparent, visible, onRequestClose, children }) => {
    if (Device.isWeb) {
        return (
            <View
                style={[
                    {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 100
                    },
                    !visible && {
                        display: 'none'
                    }
                ]}
            >
                {children}
            </View>
        );
    }
    return (
        <NativeModal
            animationType={animationType}
            transparent={transparent}
            visible={visible}
            onRequestClose={onRequestClose}
        >
            {children}
        </NativeModal>
    );
};

Modal.defaultProps = {
    transparent: false
};

Modal.propTypes = {
    animationType: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    transparent: PropTypes.bool
};

export default Modal;
